import { render, staticRenderFns } from "./EmptyRouterView.vue?vue&type=template&id=64f2d21d"
import script from "./EmptyRouterView.vue?vue&type=script&lang=js"
export * from "./EmptyRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports